import React, { useRef, useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import html2canvas from 'html2canvas';

const shareUrl = 'https://euro2008.galataanket.com';
const AnketID = 'Euro2008';
const screenshot_message ="Euro2008'deki Türkiye performansı sorularına doğru cevap oranın:";
const Firstchar ="Doğru";
const Secondchar ="Yanlış";
const Thirdchar ="Kıvılcım";
const Fourthchar ="Nilay";
const Fifthchar ="Görkem";




function Result({
  FirstCharScore,
  SecondCharScore,
  ThirdCharScore,
  FourthCharScore,
  FifthCharScore,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [email, setEmail] = useState('');
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const totalScore =
    FirstCharScore +
    SecondCharScore +
    ThirdCharScore +
    FourthCharScore +
    FifthCharScore;

  const FirstCharPercentage = (
    (FirstCharScore / totalScore) *
    100
  ).toFixed(0);
  const SecondCharPercentage = (
    (SecondCharScore / totalScore) *
    100
  ).toFixed(0);
  const ThirdCharPercentage = (
    (ThirdCharScore / totalScore) *
    100
  ).toFixed(0);
  const FourthCharPercentage = (
    (FourthCharScore / totalScore) *
    100
  ).toFixed(0);
  const FifthCharPercentage = (
    (FifthCharScore / totalScore) *
    100
  ).toFixed(0);

  const data = [
    { name: Firstchar, value: parseFloat(FirstCharPercentage),color: '#0000FF' },
    { name: Secondchar, value: parseFloat(SecondCharPercentage),color: '#FF0000' },
    { name: Thirdchar, value: parseFloat(ThirdCharPercentage),color: '#8B0000' },
    { name: Fourthchar, value: parseFloat(FourthCharPercentage),color: '#46b4a2' },
    { name: Fifthchar, value: parseFloat(FifthCharPercentage),color: '#4682B4' },
  ].filter((item) => item.value > 0);

  
  const resultRef = useRef(null);

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const handleDownloadOrShare = async () => {
    setIsLoading(true);
    try {
      const element = resultRef.current;
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: false,
        logging: false,
      });
      const dataUrl = canvas.toDataURL('image/jpeg');

      const response = await fetch(dataUrl);
      const blob = await response.blob();
      const file = new File([blob], 'Galata_Anket_Sonucu.jpeg', { type: blob.type });

      if (navigator.share && isMobileDevice()) {
        await navigator.share({
          title: 'Yakınlık Sonucu',
          files: [file],
          text: '9 soruluk anket için tıkla: ' + shareUrl,
        });
      } else {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'Galata_Anket_Sonucu.jpeg';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error('Ekran görüntüsü alınamadı veya paylaşılamadı:', error);
      alert('Ekran görüntüsü otomatik alınamadı. Siz kendiniz ekran görüntüsü alıp paylaşabilirsiniz!');
    }
    setIsLoading(false);
  };
  
  
  // const handleCopyLink = () => {
  //   navigator.clipboard
  //     .writeText(shareUrl)
  //     .then(() => {
  //       setShowWarning(true);
  //       setTimeout(() => {
  //         setShowWarning(false);
  //       }, 2000);
  //     })
  //     .catch((error) => {
  //       console.error('Link kopyalanamadı:', error);
  //       alert('Link kopyalanamadı.');
  //     });
  // };

  const handleCopyLink = async () => {
    if (navigator.share && isMobileDevice()) {
      try {
        await navigator.share({
          title: 'Anket Linki',
          text: '9 soruluk anket için tıkla: ' + shareUrl,
          url: shareUrl,
        });
        setShowWarning(true);
        setTimeout(() => {
          setShowWarning(false);
        }, 2000);
      } catch (error) {
        console.error('Link paylaşılırken hata oluştu:', error);
        alert('Link paylaşılırken bir hata oluştu.');
      }
    } else {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          setShowWarning(true);
          setTimeout(() => {
            setShowWarning(false);
          }, 2000);
        })
        .catch((error) => {
          console.error('Link kopyalanamadı:', error);
          alert('Link kopyalanamadı.');
        });
    }
  };
  

  


  const maxPercentageValue = Math.max(...data.map(item => item.value)); // Get the max value from the data

// Find all items that have the maximum value
const maxItems = data.filter(item => item.value === maxPercentageValue);

// If there's only one item with the max value, select it, otherwise set to null (or empty)
const maxPercentageItem = maxItems.length === 1 ? maxItems[0] : null;

  useEffect(() => {
    setIsModalOpen(true);
  }, []);

  return (
    <div className="result-container">
      <div className="result" ref={resultRef}>
        <img
          src={`${process.env.PUBLIC_URL}/logo_full.png`}
          alt="Logo"
          className="logo-fixed-bottom"
        />
        <hr />
        <p style={{ fontSize: '14px', marginTop: '0px' }}>
          {screenshot_message}
        </p>
        <div
          className="chart-container"
          style={{
            margin: '0',
            padding: '0',
            marginTop: '-50px',
            marginBottom: '-40px',
          }}
        >
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) =>
                  `${name}: ${(percent * 100).toFixed(0)}%`
                }
                outerRadius="40%"
                fill="#8884d8"
                dataKey="value"
                isAnimationActive={true}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {maxPercentageItem && maxPercentageItem.value > 0 && (
  <p
    style={{
      color: maxPercentageItem.color,
      fontSize: '18px',
      fontWeight: 'bold',
      marginTop: '0px',
    }}
  >
    Çoğu cevabınız: {maxPercentageItem.name}
  </p>
)}


        <hr />
        Anketi yenile:{' '}
        <a
          href={shareUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            backgroundColor: '#fff',
            padding: '2px 4px',
            borderRadius: '4px',
            textDecoration: 'none',
            color: 'black',
          }}
        >
          {shareUrl}
        </a>
      </div>

      

      <button
  className="custom-button"
  onClick={() => window.open('https://galataanket.anketekatil.com/auth/register', '_blank')}
>
  <span style={{ fontSize: '12px' }}>
    Galata Anket'ten yeni ödüllü anketler için kayıt ol
  </span>
</button>
      <p style={{ margin: '-5px' }}></p>

      <button onClick={handleCopyLink} className="button-copy-link">
        <span style={{ fontSize: '14px' }}>Anket linkini paylaş</span>
      </button>

      <button className="button-copy-link" onClick={handleDownloadOrShare}>
        <span style={{ fontSize: '14px' }}>
          {isMobileDevice() ? 'Sonucu paylaş' : 'Sonucu indir'}
        </span>
      </button>

      {isLoading && (
        <p style={{ color: 'white', fontSize: '12px', marginTop: '10px' }}>
          İşlem yapılıyor, lütfen bekleyin...
        </p>
      )}

      {showWarning && (
        <p style={{ color: 'white', fontSize: '12px', marginTop: '10px' }}>
          Link kopyalandı!
        </p>
      )}
    </div>
  );
}

export default Result;

